import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { shouldSkipHydration } from "./utils/clientRenderMode";
import { redirectToCanonicalHostIfNeeded } from "./utils/authTabSync";
import { checkAppVersionOnLoad } from "./utils/appVersionCheck";

if (typeof window !== "undefined" && redirectToCanonicalHostIfNeeded()) {
  // Canonical-host redirect in progress — skip mounting until navigation completes.
} else {

if (typeof Object.hasOwn !== "function") {
  Object.defineProperty(Object, "hasOwn", {
    value(object, property) {
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    writable: true,
  });
}

const rootElement = document.getElementById("root");
const hasPrerender = rootElement.hasChildNodes();
const skipHydration = hasPrerender && shouldSkipHydration();

if (skipHydration) {
  rootElement.innerHTML = "";
}

checkAppVersionOnLoad();

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
}
